import { lazy } from "react";
import { emailAddressGeneratorToolDefinition } from "../../salesTools/emailAddressGenerator/toolDefinition";

function lazyTool(loadTool) {
    return lazy(() =>
        loadTool().then((module) => ({
            default: module.default,
        }))
    );
}

const EmailAddressGeneratorTool = lazyTool(() => import("../../salesTools/emailAddressGenerator"));
const BasCalculatorTool = lazyTool(() => import("../tools/BasCalculatorTool"));
const ConstructionFeasibilityTool = lazyTool(() => import("../tools/ConstructionFeasibilityTool"));
const DealIntelligenceSummarySandboxTool = lazyTool(() => import("../tools/DealIntelligenceSummarySandboxTool"));
const DealSummaryFeaturePreview = lazyTool(() => import("../tools/DealSummaryFeaturePreview"));
const LeaseWaleCalculatorTool = lazyTool(() => import("../tools/LeaseWaleCalculatorTool"));
const ServicingCalculatorTool = lazyTool(() => import("../tools/ServicingCalculatorTool"));

export const INTERNAL_TOOL_REGISTRY = [
    {
        ...emailAddressGeneratorToolDefinition,
        eyebrow: "Sales Tool",
        standaloneEyebrow: "Sales Tool",
        routePath: "/email-generator",
        Component: EmailAddressGeneratorTool,
    },
    {
        key: "bas-calculator",
        title: "BAS Calculator",
        summary: "Quarter-by-quarter BAS workspace with ranked low-doc lender methods from the entered BAS only.",
        bestFor: "Quick low-doc BAS servicing reads",
        highlights: ["Quarter-by-quarter BAS entry", "Annual BAS summary", "Top 3 BAS lender methods"],
        placements: ["internal-dashboard", "broker-portal-tool", "public-tool-gallery"],
        eyebrow: "Financials",
        standaloneEyebrow: "Calculator",
        routePath: "/bas-calculator",
        Component: BasCalculatorTool,
    },
    {
        key: "construction-feasibility",
        title: "Construction Feasibility",
        summary:
            "Lender-facing construction feasibility with sources and uses, stress testing, and monthly debt visibility.",
        bestFor: "Development and construction deal shaping",
        highlights: ["Sources and uses", "Monthly facility curve", "Top 3 lender recommendations"],
        placements: ["broker-portal-tool", "public-tool-gallery"],
        eyebrow: "Development",
        standaloneEyebrow: "Calculator",
        routePath: "/construction-feasibility",
        Component: ConstructionFeasibilityTool,
    },
    {
        key: "lease-wale-calculator",
        title: "Lease WALE Calculator",
        summary: "Portfolio WALE workspace for multiple properties with rent-weighted and area-weighted lease expiry.",
        bestFor: "Single assets or full lease portfolios",
        highlights: ["Multi-property support", "Income WALE", "Area WALE"],
        placements: ["broker-portal-tool", "public-tool-gallery"],
        eyebrow: "Property",
        standaloneEyebrow: "Calculator",
        routePath: "/lease-wale-calculator",
        Component: LeaseWaleCalculatorTool,
    },
    {
        key: "servicing-calculator",
        title: "Servicing Calculator",
        summary: "Normal two-year servicing view with addbacks, existing debt, and assessed new debt.",
        bestFor: "Two-year business servicing analysis",
        highlights: ["P&L worksheet", "Rental income treatment", "Debt stack and policy ratios"],
        placements: ["internal-dashboard", "broker-portal-tool", "public-tool-gallery"],
        eyebrow: "Servicing",
        standaloneEyebrow: "Calculator",
        routePath: "/servicing-calculator",
        Component: ServicingCalculatorTool,
    },
    {
        key: "deal-intelligence-summary-sandbox",
        title: "Deal Intelligence Summary Sandbox",
        summary: "Existing deal intelligence summary preview kept as a separate internal tool module.",
        placements: ["internal-dashboard"],
        eyebrow: "Existing Tool",
        Component: DealIntelligenceSummarySandboxTool,
    },
    {
        key: "deal-summary-feature-preview",
        title: "Deal Summary Feature Preview",
        summary: "Portable Deal Summary render target without the original workspace shell.",
        placements: ["internal-dashboard"],
        eyebrow: "Portable Feature",
        Component: DealSummaryFeaturePreview,
    },
];
